import { useEffect, useRef, useState } from '@wordpress/element';
import { Dialog } from 'primereact/dialog';
import { ProgressSpinner } from 'primereact/progressspinner';

const FullTextSearchModal = () => {
	const [ visible, setVisible ] = useState( false );
	const [ loading, setLoading ] = useState( false );
	const [ html, setHtml ] = useState( '' );
	const contentRef = useRef< HTMLDivElement >( null );

	useEffect( () => {
		const onLoading = () => {
			setHtml( '' );
			setLoading( true );
			setVisible( true );
		};

		const onResult = ( e: Event ) => {
			const { detail } = e as CustomEvent< { html: string } >;
			setHtml( detail.html );
			setLoading( false );
		};

		window.addEventListener( 'wpiAiSearchLoading', onLoading );
		window.addEventListener( 'wpiAiSearchResult', onResult );

		return () => {
			window.removeEventListener( 'wpiAiSearchLoading', onLoading );
			window.removeEventListener( 'wpiAiSearchResult', onResult );
		};
	}, [] );

	useEffect( () => {
		if ( contentRef.current ) {
			contentRef.current.querySelectorAll( 'a' ).forEach( ( a ) => {
				a.setAttribute( 'target', '_blank' );
				a.setAttribute( 'rel', 'noopener noreferrer' );
			} );
		}
	}, [ html ] );

	return (
		<Dialog
			visible={ visible }
			onHide={ () => setVisible( false ) }
			header="KI-Suchergebnisse"
			style={ { width: '90vw', maxWidth: '1400px' } }
			maximizable
			draggable={ false }
			resizable={ false }
			closeIcon={ <span className="fas fa-times" /> }
			maximizeIcon={ <span className="fas fa-expand" /> }
			minimizeIcon={ <span className="fas fa-compress" /> }
		>
			{ loading ? (
				<div style={ { textAlign: 'center', padding: '3rem' } }>
					<ProgressSpinner
						style={ { width: '60px', height: '60px' } }
					/>
				</div>
			) : (
				<div
					ref={ contentRef }
					dangerouslySetInnerHTML={ { __html: html } }
				/>
			) }
		</Dialog>
	);
};

export default FullTextSearchModal;
